export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  TAG_PAGE: "tag-page",
  AUTHOR_PAGE: "author-page",
  SEARCH_PAGE: "search-page",
  STORY_PAGE: "story-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview-page",
  HOME_PREVIEW: "home-preview-page",
  STATIC_PAGE: "static-page",
  COLLECTION_PAGE: "collection-page",
  VISUAL_STORY_PAGE: "visual-story",
  USER_DETAILS: "user-details",
  SUBSCRIPTION: "subscription",
  PB_COLLECTION_PREVIEW_PAGE: "pagebuilder-collection-preview-page",
  PB_STORY_PREVIEW_PAGE: "pagebuilder-story-preview-page"
});

export const WHITELIST_CONFIG_KEYS = [
  "cdn-image",
  "sketches-host",
  "polltype-host",
  "publisher-name",
  "publisher-id",
  "env",
  "publisher-settings",
  "social-links",
  "static-pages",
  "layout",
  "sections",
  "public-integrations"
];

export const DEFAULT_FETCH_PARAM = {
  method: "POST",
  mode: "same-origin",
  cache: "no-cache",
  credentials: "same-origin",
  headers: {
    "Content-Type": "application/json"
  }
};

export const STORY_FIELDS =
  "alternative,slug,metadata,story-template,story-content-id,id,headline,hero-image-s3-key,hero-image-metadata,sections,tags,author-name,author-id,authors,created-at,first-published-at,published-at,last-published-at,url";

export const SEARCH_AGGREGATION = "story-template,author-name,section-name";

export const LOAD_MORE_LIMIT = 10;

export const DEFAULT_AMAZON_POLLY_CAPTION = "Press play to listen to this story";

export const SLIDER_ANIMATION_DURATION = 1500;

export const ATTACHMENT_TYPE = { PDF: "application/pdf" };

export const SEARCH_RESULTS_LIMIT = 10;

export const SINGLE_LAYER_ROOT_MARGIN = "56px 0px 0px 0px";

export const DOUBLE_LAYER_ROOT_MARGIN = "72px 0px 0px 0px";

export const WHITELIST_MOBILE_CONFIG = ["cdn-image"];
